export const UPDATE_AVAILABLE_PAYMENT_METHODS = 'updateAvailablePaymentMethods';
export const SET_RELOAD_AFTER_CHECKOUT = 'setReloadAfterCheckout';
export const SET_CAN_RETRY_SUBMIT = 'setCanRetrySubmit';
